import React, { useMemo, useRef } from "react"
import NProgress from "nprogress"
//import NProgress from "nprogress"
import { C, useAuthContext, useQuery, useWS } from "lib"
import useCustomNode from "./useCustomNode"
import Layout from "components/layout/Layout"
import Admin from "../Admin"
import Shell from "../Shell"
const nodeNotFound = {
    _id: {},
    _custom: true,
    type: "NotFound",
    title: "Pagină inexistentă",
    body: "Pagina nu a fost găsită.",
}

const pathField = C.LANGUAGES ? "path.p" : "path"
const buildNodeQuery = pathname => ({
    query: {
        $or: [{ [pathField]: pathname }, { alias: pathname }],
    },
})
const queryConfig = { single: true }

const useLocation = (pathname, search, language, status) => {
    const location = useRef({ pathname, search, language, first: true })
    const prevStatus = useRef(status)

    if (location.current.pathname === pathname) location.current.search = search
    else {
        if (status !== "loading") {
            location.current = { pathname, search, language, first: false }
        }
    }
    prevStatus.current = status
    return location.current
}

const useNodeRetriever = pathname => {
    const state = useRef({})
    //const custom = useRef()
    const customNode = useCustomNode(pathname)
    useMemo(() => {
        if (
            C.LANGUAGES &&
            state.current.node &&
            state.current.node.path.filter(path => path.p === pathname).length > 0
        )
            return

        //custom.current = useCustomNode(pathname)
        if (customNode) {
            state.current.query = null
        } else {
            state.current.query = buildNodeQuery(pathname)
        }
    }, [pathname, customNode])

    const [resultNode, status] = useQuery(state.current.query, queryConfig)
    //const prevNode = state.current.node
    //const currentNode =
    //console.log(status)
    if (customNode || status === "loaded") {
        state.current.node = customNode || resultNode
        //console.log(state.current.node)
        if (typeof window !== "undefined") {
            requestAnimationFrame(() => {
                NProgress.done()
            })
        }
        return [state.current.node, "loaded"]
    }
    return [state.current.node, status]
    /*if (customNode) {
        state.current.node = customNode
        return [customNode, "loaded"]
    }
    state.current.node = resultNode || customNode
    return [state.current.node, status]*/
}
const NodeManager = ({ pathname, search, language }) => {
    useWS()
    const { user, logout } = useAuthContext()
    const [resultNode, status] = useNodeRetriever(pathname)
    const location = useLocation(pathname, search, language, status)
    const node = status === "loaded" ? resultNode || nodeNotFound : resultNode
    /*
    console.log(
        "render",
        location.pathname,
        location.search,
        status,
        node ? node.path : null,
        resultNode
    )*/
    //console.log(location)
    if (user && user.isAdmin && location.search["mode"] && location.search["mode"] === "design") {
        return <Admin user={user} logout={logout} node={node} pathname={location.pathname} design />
    }
    if (user && user.isAdmin && pathname === "/shell") {
        return <Shell user={user} logout={logout} node={node} pathname={location.pathname} />
    }

    return (
        <>
            <Layout
                location={location.pathname}
                search={location.search}
                language={location.language}
                node={node}
                first={location.first}
            />
            <Admin user={user} logout={logout} node={node} />
        </>
    )
}

export { buildNodeQuery }
export default React.memo(NodeManager)
